import { Info } from 'lucide-react';
import CustomTooltip from '../CustomTooltip/CustomTooltip';

interface InfoTooltipProps {
  readonly content: string;
  readonly label?: string;
}

export default function InfoTooltip({
  content,
  label = 'More information'
}: InfoTooltipProps): JSX.Element {
  return (
    <CustomTooltip content={content}>
      <button
        type='button'
        aria-label={label}
        className='inline-flex cursor-help text-muted-foreground transition-colors hover:text-foreground focus:outline-none focus-visible:text-foreground'
      >
        <Info size={14} aria-hidden='true' />
      </button>
    </CustomTooltip>
  );
}
